import React, {useReducer} from "react";
import {map} from "lodash";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {Collapse, ListItemText} from "@mui/material";
import styled from "styled-components";
import {IHelp} from "modules/actions";
import {SectionAccordionButton, SectionContainer, SectionContent, SectionWrapper} from "./common";

const Wrapper = styled.div`
	border-bottom: 1px solid #cccccc;
`;

interface IListItem {
	title: string;
	text: string;
}

const ListItem: React.FC<IListItem> = ({title, text}) => {
	const [isOpen, toggleIsOpen] = useReducer((isOpen) => !isOpen, false);

	return (
		<Wrapper>
			<SectionAccordionButton onClick={toggleIsOpen}>
				<ListItemText primary={title} />
				{isOpen ? <ExpandLess /> : <ExpandMore />}
			</SectionAccordionButton>
			<Collapse in={isOpen}>
				<SectionContainer>
					<SectionContent dangerouslySetInnerHTML={{__html: text}} />
				</SectionContainer>
			</Collapse>
		</Wrapper>
	);
};

export interface IHelpList {
	list: IHelp[];
}

export const HelpList: React.FC<IHelpList> = ({list}) => {
	if (!list.length) {
		return null;
	}

	return (
		<SectionWrapper>
			{map(list, ({title, id, text}) => (
				<ListItem key={id} title={title} text={text} />
			))}
		</SectionWrapper>
	);
};
